import _ from 'lodash';

/**
 * @param {Object} storeState - Redux root state
 * @returns {Object} Props for ChildOrganizationDashboard
 */
export default function selector(storeState) {
    const childOrgState = _.get(storeState, 'adminV2.childOrganization') ?? {};
    const {
        currentOrganization,
        filteredUsers,
        isPageLoading,
        isSideBarLoading,
        isTableLoading,
        filteredOrganizationsList,
        organizationsForList,
        ownOrganizationType,
        users,
        usersByOrgId,
    } = childOrgState;
    const ownOrganizationId = _.get(storeState, 'profile.organizationId');
    const currentUserId = _.get(storeState, 'profile.userId');
    const profileOwnOrganizationType = _.get(storeState, 'profile.ownOrganization.type', '');
    return {
        currentOrganization,
        filteredUsers,
        isPageLoading,
        isSideBarLoading,
        isTableLoading,
        filteredOrganizationsList,
        organizationsForList,
        // Profile is available before child-org fetch; slice value wins after fetch completes
        ownOrganizationType: ownOrganizationType || profileOwnOrganizationType,
        users,
        // Default empty object — deprecate modal reads user counts from this cache at open
        usersByOrgId: usersByOrgId ?? {},
        ownOrganizationId,
        currentUserId,
    };
}
